import React from 'lib/react';
import { useDispatch, useSelector } from 'lib/redux';
import { ORDER_HISTORY_FILTERS_UPDATE_STATUS_LIST } from 'constants/ActionTypes';
import {
  EVCheckOutlinedIcon, EVGrid, EVTypography,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import { getStatusValues } from 'features/orderHistory/OrderHistory.utils';
import MultiSelectFilterOptions from '../../commonComponents/multiSelectFilterOptions';

function StatusFilter() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const defaultStatusValues = getStatusValues(t);
  const { statusList: selectedStatuses } = useSelector(({ orderHistory }) => orderHistory.orderHistoryFilters);

  const handleChange = (value) => {
    const selectedStatusesSet = new Set(selectedStatuses);
    if (selectedStatusesSet.has(value)) selectedStatusesSet.delete(value);
    else selectedStatusesSet.add(value);

    dispatch({ type: ORDER_HISTORY_FILTERS_UPDATE_STATUS_LIST, statusList: [...selectedStatusesSet] });
  };
  const handleClear = () => {
    dispatch({ type: ORDER_HISTORY_FILTERS_UPDATE_STATUS_LIST, statusList: [] });
  };

  const menuItemComponent = (id, name) => (
    <EVGrid style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      {selectedStatuses?.some((item) => item === id)
        ? <EVCheckOutlinedIcon style={{ height: '24px', width: '24px' }} />
        : <EVGrid style={{ width: '24px' }} />}
      <EVTypography style={{ width: 'fit-content' }}>{name}</EVTypography>
    </EVGrid>
  );

  const statusOptions = Object.entries(defaultStatusValues).map(([key, { name, color, backgroundColor }]) => ({
    id: key,
    description: menuItemComponent(key, name),
    name,
    color,
    backgroundColor,
  }));

  return (
    <MultiSelectFilterOptions
      filterId="status-filter"
      filterName={t('common__status')}
      handleChange={handleChange}
      handleClear={handleClear}
      optionsList={statusOptions}
      selectedOptions={selectedStatuses}
    />
  );
}

export default StatusFilter;
